import { Injectable, inject } from '@angular/core';
import { Params, Router } from '@angular/router';
import { ProjectService } from 'src/app/core/services/project.service';
import { DeliverableTabUrls } from 'src/app/deliverables-status/deliverables-utils';
import { ReviewFilterValues } from 'src/app/review-deprecated/review-filters.pipe';
import { ReviewTabUrl } from 'src/app/review-deprecated/review.component';

interface DeliverableRouterLink {
  link: string;
  queryParams?: Params;
}

@Injectable({ providedIn: 'root' })
export class NavigationService {
  readonly #router = inject(Router);
  readonly #projectService = inject(ProjectService);
  readonly #projectId = this.#projectService.currentProjectId;

  navigateToDeliverableProfile(deliverableId: number, taskId?: number, projectId?: number) {
    const queryParams: Params = taskId ? { taskId } : {};
    const targetProjectId = projectId ?? this.#projectId();

    this.#router.navigate([`/projects/${targetProjectId}/deliverables-status/${deliverableId}/profile`], {
      queryParams,
      queryParamsHandling: 'merge', // Merge new queryParams with the current ones
    });
  }

  getDeliverableReviewLink(deliverableId: number, deliverableType: string, packageId: number) {
    const queryParams: Params = { mode: 'review', packageId };
    deliverableType = deliverableType.toLowerCase().replace('_', '-').replace('model-3d', '3d-model');
    return {
      link: `/projects/${this.#projectId()}/deliverables-status/${deliverableId}/profile/${deliverableType}`,
      queryParams,
    } as DeliverableRouterLink;
  }

  #hasNavigatedToDashboard = false;

  navigateToDashboard(projectId: number | undefined) {
    const isFirstNavigation = !this.#hasNavigatedToDashboard;
    this.#hasNavigatedToDashboard = true;
    if (projectId) {
      this.#router.navigate([`/projects/${projectId}/dashboard`], { replaceUrl: isFirstNavigation });
    } else {
      this.#router.navigate(['/projects'], { replaceUrl: true });
    }
  }

  navigateToAlias() {
    this.#router.navigate(['/alias']);
  }

  navigateToDeliverablesStatus(tab: DeliverableTabUrls, packageId: number) {
    this.#router.navigate([`/projects/${this.#projectId()}/deliverables-status`], {
      queryParams: { packageId, deliverableStatusTab: tab },
    });
  }

  navigateToReview(tab: ReviewTabUrl, filters: ReviewFilterValues) {
    this.#router.navigate([`/projects/${this.#projectId()}/review/${tab}`], {
      queryParams: { filters: JSON.stringify(filters) },
    });
  }
}
